<template>
  <div>
    <template v-if="itemList!=''">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
      <div class="itemList">
        <ul>
          <li class="fl" v-for="(item,index) in itemList" :key="index">
            <router-link  :to="{ path: '/itemDetails', query: { service_id: item.id ,store_id:store_id,tech_id:tech_id}}" class="bg_fff radius3">
              <img :src="item.thumb_frist" alt="">
              <div class="itemList_content">
                <p class="itemList_title one">{{item.title}}</p>
                <p class="itemList_price"><span>￥{{item.price}} 起</span>{{item.itemtime}}分钟/次</p>
              </div>
            </router-link>
          </li>
        </ul>
      </div>
    </van-list>
    </template>
    <template v-else>
      <div class="item_none">暂无服务项目</div>
    </template>
    
  </div>
</template>

<script>
  export default {
    name: "itemList",
    data(){
      return{
        //项目列表
        itemList: [
          // {img:"/static/img/itemList_img1.png",title:"体验按摩",price:"39.00",time:"15"},
          // {img:"/static/img/itemList_img2.png",title:"推油养生",price:"320.00",time:"60"},
          // {img:"/static/img/itemList_img3.png",title:"拔罐养生",price:"60.00",time:"10"}
        ],
        loading:false,
        finished:true,
        tech_id:0,
        store_id:0,
      }
    },
    methods: {
      onLoad() {
        // // 异步更新数据
        // setTimeout(() => {
        //   for (let i = 0; i < 3; i++) {
        //     this.itemList.push(this.itemList[0]);
        //   }
        //   // 加载状态结束
        //   this.loading = false;

        //   // 数据全部加载完成
        //   if (this.itemList.length >= 20) {
        //     this.finished = true;
        //   }
        // }, 500);
      }
    },
    created(){
      this.tech_id = this.$route.query.tech_id;
      this.store_id = this.$route.query.store_id;
      this.axios({
          url: this.api.service.service_list,
          data:{
            tech_id:this.tech_id,
            store_id:this.store_id
          }
      }).then((res) => {
          if (res.error === 0) {
            this.itemList  = res.service_data           
          }

      })
    }
  }
</script>

<style scoped>
  @import '../../../assets/css/item.css';   /*(服务)项目样式*/
  .item_none{
    padding-top: 10%;
    text-align: center;
    color: darkgrey;
    font: 1rem;
  }
  /* 一行显示 */
.one {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  line-height: 18px;
}
</style>



// WEBPACK FOOTER //
// src/views/book/item/itemList.vue